module.exports = __webpack_public_path__ + "producr-dried fresh-grass-main-thumb-01.jpg?81d310c12a2a1a81c1a79ce361de333d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-main-thumb-01.jpg
// module id = 56
// module chunks = 0